const JSBridge = require("@/libs/JSBridge")
const cookie = require("@/libs/cookie");

const platforms = ['M2', 'PcWeb', 'MobileWeb', 'iOS', 'ANDROID', 'WechatMiniprogram']

/** * 对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
 可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) * eg: * (new
 Date()).pattern("yyyy-MM-dd hh:mm:ss.S")==> 2006-07-02 08:09:04.423
 * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 */
Date.prototype.pattern = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  var week = {
    "0": "\u65e5",
    "1": "\u4e00",
    "2": "\u4e8c",
    "3": "\u4e09",
    "4": "\u56db",
    "5": "\u4e94",
    "6": "\u516d"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "\u661f\u671f" : "\u5468") : "") + week[this.getDay() + ""]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

module.exports = {
  getYuanStr(price) {
    var result = '',
      counter = 0;
    var num = (price.toString().split(".")[0] || 0).toString();
    for (var i = num.length - 1; i >= 0; i--) {
      counter++;
      result = num.charAt(i) + result;
      if (!(counter % 3) && i != 0) {
        result = ',' + result;
      }
    }
    return result;
  },
  getFenStr(price) {
    var arr = price.toString().split(".");
    if (arr.length > 1) {
      if (arr[1].length > 1) {
        return arr[1]
      } else {
        return arr[1] + "0"
      }
    }
    return "00";
  },
  formatPrice(price) {
    return this.getYuanStr(price) + "." + this.getFenStr(price)
  },
  // 获取url参数
  getUrlKey: function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || ''
  },
  getClientPlatform() {
    var platform = this.getUrlKey('platform') || cookie.get("platform") || window.sessionStorage.getItem("platform") || ''
    // alert('storage.platform:' + window.sessionStorage.getItem("platform"))
    const index = platforms.findIndex(item => item.toLowerCase() === platform.toLowerCase())
    platform = index > -1 ? platforms[index] : 'iOS'
    // platform = index > -1 ? platforms[index] : 'WechatMiniprogram'
    console.log('platform: ', index, platform)
    // 防止app back的时候会清cookie
    window.sessionStorage.setItem("platform", platform)
    return platform
  },
  getClientVersion() {
    var version = this.getUrlKey('app_version') || window.sessionStorage.getItem("app_version") || cookie.get("app_version") || ''
    version = version && version !== 'undefined' ? version : '2.17.0'
    // 防止app back的时候会清cookie
    window.sessionStorage.setItem("app_version", version)
    return version
  },
  getPersonalized() {
    var personalized = this.getUrlKey('personalized') || cookie.get("personalized") || window.sessionStorage.getItem("personalized") || ''
    personalized = personalized && personalized !== 'undefined' ? personalized : ''
    // 防止app back的时候会清cookie
    window.sessionStorage.setItem("personalized", personalized)
    return personalized
  },
  getDeviceId() {
    var deviceId = this.getUrlKey('deviceId') || cookie.get("deviceId") || window.sessionStorage.getItem("deviceId") || ''
    deviceId = deviceId && deviceId !== 'undefined' ? deviceId : ''
    // 防止app back的时候会清cookie
    window.sessionStorage.setItem("deviceId", deviceId)
    return deviceId
  },
  // 同步获取token
  getTokenSync() {
    var token = this.getUrlKey('token') || window.sessionStorage.getItem("token") || cookie.get("token") || cookie.get("accessToken") || ''
    token = token && token !== 'undefined' ? `Bearer ${token.replace("Bearer ", "")}` : ''
    // 防止app back的时候会清cookie
    window.sessionStorage.setItem("token", token)
    return token
  },
  // 异步获取token，app且版本2.4.0以上，会先refreshToken
  getToken(callback) {
    callback && callback(this.getTokenSync())
    // const platform = this.getClientPlatform()
    // const version = this.getClientVersion()
    // if ((platform === 'iOS' || platform === 'ANDROID') && version >= '2.4.0') {
    //   JSBridge.callHandler('refreshedToken', null, res => {
    //     callback && callback(res.token)
    //   })
    // } else {
    //   callback && callback(this.getTokenSync())
    // }
  },
  trackEvent(event, params) {
    let platform = cookie.get("platform") || this.getUrlKey('platform')
    platform = platform.toLowerCase()
    // from app, use js bridge
    if (platform === 'android' || platform === 'ios') {
      const para = {
        'event': event,
        'params': params,
      }
      JSBridge.callHandler('onTrackEvent', para)
    } else {
      window.ikeaapp.tools.trackEvent(event, params)
      window.gio && window.gio('track', event, params)
    }
  },
  getProductTypeShort(type) {
    let t = ''
    if (type === 'SPR') {
      t = 's'
    } else if (type === 'VTP') {
      t = 'v'
    }
    return t
  },
  parseURL(url) {
    var wholePath = url.split('//')[1] ? url.split('//')[1].split('?')[0] : ''
    var host = wholePath.split('/')[0]
    var path = wholePath.replace(host, '')
    var query = url.split('?')[1] ? url.split('?')[1] : ''
    return {
      source: url,
      protocol: url.split(':')[0],
      host: host,
      query: query,
      params: (function () {
        var params = {},
          seg = query.split('&'),
          len = seg.length,
          p;
        for (var i = 0; i < len; i++) {
          if (seg[i]) {
            p = seg[i].split('=');
            params[p[0]] = p[1];
          }
        }
        return params;
      })(),
      path: path
    };
  }
}



// WEBPACK FOOTER //
// ./src/libs/utils.js